import { BatchUploadFormType } from './types';
import * as yup from 'yup';

export const BatchUploadFormInitialValues: BatchUploadFormType = {
  batchDescription: null,
  batchName: null,
  folderName: '',
  file: {
    file: null,
    fileBaseTo64: '',
  },
  fileName: '',
};

export const BatchUploadFormValidationSchema = yup.object().shape({
  file: yup.mixed().nullable().required('Campo obbligatorio'),
});
